// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.signup-container {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 80px 0;
  height: 100vh;
  text-align: center;
  font-family: "Proxima Nova", sans-serif;
}
.signup-container.modal {
  justify-content: center;
  padding: 0;
}
.signup-container.modal .form {
  margin-top: 0;
  justify-content: center;
}
.signup-container.modal .form .sign-up {
  margin-top: 40px;
}
.signup-container .select-user-type-container, .signup-container .account-container, .signup-container .info-container {
  animation: fadein 0.5s;
}
.signup-container .form {
  margin-top: 128px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
}
.signup-container .form .back {
  font-size: 12px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
}
.signup-container .form .header {
  font-size: 32px;
  color: var(--secondary-color-1);
  font-weight: 700;
  line-height: 36px;
}
.signup-container .form .subheader {
  color: #949494;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}
.signup-container .form .password-checklist {
  display: flex;
  flex-direction: column;
  width: 300px;
  row-gap: 8px;
}
.signup-container .form .password-checklist > li {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: 0.2s ease-in-out;
}
.signup-container .form .password-checklist > li.active p {
  color: var(--primary-color-1);
  font-weight: 700;
}
.signup-container .form .password-checklist > li p {
  margin: 0;
  font-size: 12px;
  color: #949494;
}
.signup-container .sign-up {
  margin: 0;
  font-size: 14px;
  font-weight: 400;
  color: var(--secondary-color-3);
}
.signup-container .sign-up > span {
  margin-left: 10px;
  font-weight: 700;
  color: var(--primary-color-1);
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
}
@keyframes fadeIn {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .signup-container {
    margin-bottom: 40px;
  }
  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/Authentication/modules/Signup/signup.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,aAAA;EACA,kBAAA;EACA,uCAAA;AAFJ;AAGI;EACI,uBAAA;EACA,UAAA;AADR;AAEQ;EACI,aAAA;EACA,uBAAA;AAAZ;AACY;EACI,gBAAA;AAChB;AAGI;EACI,sBAAA;AADR;AAGI;EACI,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,YAAA;AADR;AAEQ;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;AAAZ;AAEQ;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAEQ;EACI,aAAA;EACA,sBAAA;EACA,YAAA;EACA,YAAA;AAAZ;AACY;EACI,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;AAChB;AACoB;EACI,6BAAA;EACA,gBAAA;AACxB;AAEgB;EACI,SAAA;EACA,eAAA;EACA,cAAA;AAApB;AAKI;EACI,SAAA;EACA,eAAA;EACA,gBAAA;EACA,+BAAA;AAHR;AAIQ;EACI,iBAAA;EACA,gBAAA;EACA,6BAAA;EACA,eAAA;EACA,yBAAA;UAAA,iBAAA;AAFZ;AAKI;EACI;IAAK,UAAA;EAFX;EAGM;IAAO,UAAA;EAAb;AACF;;ACvFY;ED2FR;IACI,mBAAA;EAAN;EACM;IACI;MAAK,UAAA;IAEb;IADQ;MAAO,UAAA;IAIf;EACF;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\r\n\r\n.signup-container {\r\n    flex: 1;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    // justify-content: space-between;\r\n    padding: 80px 0;\r\n    height: 100vh;\r\n    text-align: center;\r\n    font-family: 'Proxima Nova', sans-serif;\r\n    &.modal {\r\n        justify-content: center;\r\n        padding: 0;\r\n        .form {\r\n            margin-top: 0;\r\n            justify-content: center;\r\n            .sign-up {\r\n                margin-top: 40px;\r\n            }\r\n        }\r\n    }\r\n    .select-user-type-container, .account-container, .info-container {\r\n        animation: fadein .5s;\r\n    }\r\n    .form {\r\n        margin-top: 128px;\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: space-between;\r\n        height: 100%;\r\n        .back {\r\n            font-size: 12px;\r\n            font-weight: 700;\r\n            color: var(--secondary-color-1);\r\n            margin: 0;\r\n        }\r\n        .header {\r\n            font-size: 32px;\r\n            color: var(--secondary-color-1);\r\n            font-weight: 700;\r\n            line-height: 36px;\r\n        }\r\n        .subheader {\r\n            color: #949494;\r\n            font-size: 20px;\r\n            font-weight: 400;\r\n            line-height: 24px;\r\n        }\r\n        .password-checklist {\r\n            display: flex;\r\n            flex-direction: column;\r\n            width: 300px;\r\n            row-gap: 8px;\r\n            > li {\r\n                display: flex;\r\n                justify-content: space-between;\r\n                align-items: center;\r\n                transition: .2s ease-in-out;\r\n                &.active {\r\n                    p { \r\n                        color: var(--primary-color-1); \r\n                        font-weight: 700;\r\n                    }\r\n                }\r\n                p {\r\n                    margin: 0;\r\n                    font-size: 12px;\r\n                    color: #949494;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .sign-up {\r\n        margin: 0;\r\n        font-size: 14px;\r\n        font-weight: 400;\r\n        color: var(--secondary-color-3);\r\n        > span {\r\n            margin-left: 10px;\r\n            font-weight: 700;\r\n            color: var(--primary-color-1);\r\n            cursor: pointer;\r\n            user-select: none;\r\n        }\r\n    }\r\n    @keyframes fadeIn {\r\n        0% { opacity: 0; }\r\n        100% { opacity: 1; }\r\n    }\r\n}\r\n\r\n@include media(mobile) {\r\n    .signup-container {\r\n        margin-bottom: 40px;\r\n        @keyframes fadeIn {\r\n            0% { opacity: 0; }\r\n            100% { opacity: 1; }\r\n        }\r\n    }\r\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
